import moment from 'moment'
import { API } from '@/models/core'

export class CricketRelativeMatch {
  get didPlayerBat () {
    if (this.player.stats.bat.balls === undefined || this.player.stats.bat.balls === null) {
      return false
    }

    return true
  }

  get didPlayerBowl () {
    if (this.player.stats.bowl.balls) {
      return true
    }
    return false
  }

  get didPlayerBatOrBowl () {
    return this.didPlayerBat || this.didPlayerBowl
  }

  static createFromJson (forPlayer, forTeam, raw) {
    let match = new CricketRelativeMatch()
    match = Object.assign(match, raw)

    match.forPlayer = forPlayer
    match.forTeam = forTeam
    match.match.startAt = moment.unix(match.match.start)

    let teamIndex = null
    if (forPlayer) {
      teamIndex = match.player.team_index
    } else if (match.match.team_index) {
      teamIndex = match.match.team_index
    }

    const vsTeamIndex = (teamIndex === 'a') ? 'b' : 'a'

    let winnerTeam = null
    if (match.match.result === 'win') {
      winnerTeam = teamIndex
    } else if (match.match.result === 'lost') {
      winnerTeam = vsTeamIndex
    }

    match.match.winnerTeam = winnerTeam

    if (match.forTeam === null) {
      match.forTeam = match.match.teams[match.player.team_index]
    }

    match.teamIndex = teamIndex
    match.vsTeamIndex = vsTeamIndex
    return match
  }
}

export class CricketPlayerPerformance {
  get isBetterAtBat () {
    let batInn = this.bat.innings
    let bowlInn = this.bowl.innings
    const total = Math.max(batInn, bowlInn)

    if (total === 0 || bowlInn === 0) {
      return true
    }

    batInn = (batInn / total) * 100
    bowlInn = (bowlInn / total) * 100

    if (bowlInn > batInn) {
      // All rounders sometimes have few innings more on bowling
      const delta = bowlInn - batInn
      return delta < 2
    }

    return true
  }

  static fetch (player, coverage) {
    let url = `/cricket/player/${player.key}/performance/${coverage.board}/${coverage.competition}/`
    let params = {}

    if (coverage.year) {
      url += `${coverage.year}/`
    }

    if (coverage.vsTeam) {
      params['vsteam'] = coverage.vsTeam
    }

    return API.instance().get(url, { params }).then((resp) => {
      const raw = resp.data.data
      const stats = CricketPlayerPerformance.createFromJson(player, raw.stats)
      return stats
    })
  }

  static fetchTimeline (page, player, coverage) {
    let url = `/cricket/player/${player.key}/timeline/${coverage.board}/${coverage.competition}/`
    let params = {}

    if (coverage.year) {
      url += `${coverage.year}/`
    }

    if (coverage.vsTeam) {
      params['vsteam'] = coverage.vsTeam
    }

    if (page) {
      params['page'] = page
    }

    return API.instance().get(url, { params }).then((resp) => {
      const response = resp.data.data.matches
      response.matches = response.matches.map((matchRaw) => {
        return CricketRelativeMatch.createFromJson(player, null, matchRaw)
      })
      return response
    })
  }

  static createFromJson (player, raw) {
    let performance = new CricketPlayerPerformance()
    performance = Object.assign(performance, raw)
    performance.player = player

    performance.upcoming_matches = performance.upcoming_matches.map((matchRaw) => {
      return CricketRelativeMatch.createFromJson(player, null, matchRaw)
    })

    const metrics = ['bat', 'bowl']
    metrics.forEach((metricKey) => {
      if (performance[metricKey]) {
        const metric = performance[metricKey]
        if (metric.best && metric.best.match) {
          metric.best = CricketRelativeMatch.createFromJson(player, null, metric.best)
        } else {
          metric.best = null
        }

        metric.previous_matches = metric.previous_matches.map((matchRaw) => {
          return CricketRelativeMatch.createFromJson(player, null, matchRaw)
        })
      }
    })

    return performance
  }
}

export class CricketTeamPerformance {
  static fetch (team, coverage) {
    let url = `/cricket/team/${team.key}/performance/${coverage.board}/${coverage.competition}/`
    let params = {}

    if (coverage.year) {
      url += `${coverage.year}/`
    }

    if (coverage.vsTeam) {
      params['vsteam'] = coverage.vsTeam
    }

    return API.instance().get(url, { params }).then((resp) => {
      const raw = resp.data.data
      const stats = CricketTeamPerformance.createFromJson(team, raw.stats)
      return stats
    })
  }

  static fetchTimeline (page, team, coverage) {
    let url = `/cricket/team/${team.key}/timeline/${coverage.board}/${coverage.competition}/`
    let params = {}

    if (coverage.year) {
      url += `${coverage.year}/`
    }

    if (coverage.vsTeam) {
      params['vsteam'] = coverage.vsTeam
    }

    if (page) {
      params['page'] = page
    }

    return API.instance().get(url, { params }).then((resp) => {
      const response = resp.data.data.matches
      response.matches = response.matches.map((matchRaw) => {
        return CricketRelativeMatch.createFromJson(null, team, matchRaw)
      })
      return response
    })
  }

  static createFromJson (team, raw) {
    let performance = new CricketTeamPerformance()
    performance = Object.assign(performance, raw)
    performance.team = team

    performance.upcoming_matches = performance.upcoming_matches.map((matchRaw) => {
      return CricketRelativeMatch.createFromJson(null, team, matchRaw)
    })

    performance.previous_matches = performance.previous_matches.map((matchRaw) => {
      return CricketRelativeMatch.createFromJson(null, team, matchRaw)
    })

    Object.keys(performance.stats).forEach((metricKey) => {
      if (performance.stats[metricKey] && performance.stats[metricKey].match) {
        performance.stats[metricKey] = CricketRelativeMatch.createFromJson(null, team, performance.stats[metricKey])
      } else if (performance.stats[metricKey] !== undefined) {
        performance.stats[metricKey] = undefined
      }
    })

    return performance
  }
}
